import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import Button from "react-bootstrap-button-loader";
import {
  toggleEditContentTabNameEditor,
  updateContentTabName,
} from "ContentActions";
import { showError } from "ReduxErrorBar";

class EditIconName extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  renderFieldText(field) {
    let charactersLeft = "";
    var divClassName = `${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    var inputClasses = "";
    if (field.maxlength) {
      charactersLeft = field.maxlength - field.input.value.length;
    }
    return (
      <div className={divClassName}>
        <div
          className={inputClasses}
          style={{ marginTop: "3px", position: "relative" }}
        >
          <input
            className="form-control"
            type={field.type}
            placeholder={field.placeholder}
            {...field.input}
            maxLength={field.maxlength ? field.maxlength : ""}
          />
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
          {field.maxlength ? (
            <span className="char-left-menuname">
              {field.input.value.length}
              {" / "}
              {field.maxlength}
            </span>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }

  onChange = (e) => {
    /*var val=e.target.value;
    if(val.length>0){
      this.setState({loading:true});
      var valuesToSubmit={displaytabname:val,apptabid:this.props.tab.apptabid}
      this.props.updateContentTabName(this.props.session,valuesToSubmit,(response)=>{
            if(response.error){
              this.props.showError('There was an error updating Tab name!!');
            }
            this.setState({loading:false});
      });
    }*/
  };

  onFormSubmit(values) {
    values.displaytabname = values.displaytabname.trim();
    this.setState({ loading: true });
    var valuesToSubmit = { ...values, apptabid: this.props.tab.apptabid };
    this.props.updateContentTabName(
      this.props.session,
      valuesToSubmit,
      (response) => {
        if (!response.error) {
          this.props.finishOperationsCallback();
          setTimeout(() => {
            this.setState({ loading: false });
            this.props.toggleEditContentTabNameEditor(false);
          }, 1000);
        } else {
          this.setState({ loading: false });
          this.props.showError("There was an error updating Tab name!");
        }
      }
    );
  }

  closeEdit() {
    this.props.toggleEditContentTabNameEditor(false);
  }

  render() {
    var { handleSubmit, invalid, pristine, submitting } = this.props;
    return (
      <div>
        <form
          onSubmit={handleSubmit(this.onFormSubmit.bind(this))}
          className="animated fadeIn"
          style={{ display: "-webkit-inline-flex" }}
        >
          <Field
            name="displaytabname"
            label=""
            placeholder=""
            type="text"
            component={this.renderFieldText}
            onChange={this.onChange}
            maxlength={15}
          />
          {/* style={{width:32,height:32,marginLeft:5,marginTop:-8}} */}
          {/* style={{fontSize:18,marginLeft:-3}} */}
          <Button
            className="btn btn-i-custom-blue"
            style={{ marginLeft: 5, marginTop: 5 }}
            type="submit"
            disabled={pristine || invalid || submitting}
          >
            <i className="fa fa-save"></i>
          </Button>
          <button
            type="button"
            className="i-custom-table-delete"
            style={{ marginLeft: 5, marginTop: 4 }}
            onClick={this.closeEdit.bind(this)}
          >
            {/* <span aria-hidden="true">X</span> */}
            <img src="../../style/images/custom-icons/shape-1317-copy-3.svg" />
          </button>
        </form>
      </div>
    );
  }
}

function validate(values) {
  var errors = {};

  if (!values.displaytabname || values.displaytabname.trim() === "") {
    errors.displaytabname = "Please input Tab Name!";
  }

  return errors;
}

function mapStateToProps(state, ownProps) {
  return {
    session: state.session,
    initialValues: { displaytabname: ownProps.tab.displayname },
  };
}

export default connect(mapStateToProps, {
  toggleEditContentTabNameEditor,
  updateContentTabName,
  showError,
})(
  reduxForm({
    form: "EditIconNameForm",
    validate,
    enableReinitialize: true,
  })(EditIconName)
);
